import { css } from '@emotion/core';
import { Collapse, Icon } from 'antd';
import React from 'react';

import Heading from '@/src/shared/components/Heading';

export const filterCollapseProps = {
  bordered: false,
  expandIconPosition: 'right',
  expandIcon: ({ isActive }) => <Icon type={isActive ? 'minus' : 'plus'} />,
};

export const FILTER_KEY = '1';

const FilterSection = props => {
  const { label, children, defaultActiveKey, headerTag, keyProp, ..._props } = props;
  const collapseProps = {
    ...filterCollapseProps,
    ..._props,
  };
  return (
    <Collapse {...collapseProps} defaultActiveKey={defaultActiveKey}>
      <Collapse.Panel
        key={keyProp}
        header={
          <Heading type={headerTag || 4} weight="bolder" theme="primaryGray">
            {label}
          </Heading>
        }
      >
        {children}
      </Collapse.Panel>
    </Collapse>
  );
};

export default FilterSection;
